'use es6';

export const getGlobalGroupsDataByPath = state => state.globalGroups.widgets.widgetsByPath;